import { useMediaQuery } from './useMediaQuery';

/**
 * The platform's single mobile breakpoint. The operator chrome (AppLayout
 * mobile branch, bottom nav) uses ≤1023px as "mobile", so the pillar pages
 * share the same threshold to stay in lockstep with the surrounding shell.
 *
 * (The legacy attendee swipe-shell uses a separate 768px breakpoint; that is
 * intentionally left alone for the reunion app.)
 */
export const MOBILE_MAX_WIDTH = 1023;

/**
 * True when the viewport is in the operator "mobile" range (≤1023px). Use this
 * in pillar pages to branch to mobile-appropriate layouts instead of hand-
 * rolling a `useMediaQuery(1023)` call in every file.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_MAX_WIDTH);
}
